import { SettingsDesktopView, type SettingsSection } from './SettingsDesktopView';
import type { User } from '../../auth/api';

export function SettingsTabletView(props: { section?: SettingsSection; user: User }) {
  return <SettingsDesktopView {...props} />;
}
